"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitializeMethodFiReason = void 0;
var InitializeMethodFiReason;
(function (InitializeMethodFiReason) {
    InitializeMethodFiReason["alreadyInitialized"] = "alreadyInitialized";
    InitializeMethodFiReason["fraudIndicator"] = "fraudIndicator";
    InitializeMethodFiReason["initializationFailed"] = "initializationFailed";
})(InitializeMethodFiReason || (exports.InitializeMethodFiReason = InitializeMethodFiReason = {}));
